<template>
    <div class="flex-grow-1 px-1 py-6 overflow-y-auto bg-white">
        <!-- Step: Form Details -->
        <div v-if="currentComponent === 'FormDetailsStep'">
            <div class="form-section form-box">
                <label class="form-label">Form name <span class="required">*</span></label>
                <input type="text" class="form-input" placeholder="Name your form"
                    v-model="store.MetaLeedDetails.formName" />
            </div>

            <div class="form-box shadow">
                <div v-if="store.MetaLeedDetails.enableGreeting">
                    <div class="form-section">
                        <label class="form-label">Headline <span class="required">*</span></label>
                        <input type="text" class="form-input" placeholder="Leads Ad headline"
                            v-model="store.MetaLeedDetails.headline" />
                    </div>
                    <div class="form-section">
                        <label class="form-label">Description <span class="required">*</span></label>
                        <textarea class="form-textarea" placeholder="Leads Ad description"
                            v-model="store.MetaLeedDetails.description"></textarea>
                    </div>
                </div>
            </div>
        </div>

        <!-- Errors -->
        <div v-if="error.length" class="error-list mb-4 mt-6">
            <p v-for="(err, index) in error" :key="index" class="text-error">⚠ {{ err }}</p>
        </div>

    </div>
</template>

<script>
import QuestionsStep from '@/components/SuperApp/Awareness/LeedForm/Meta/QuestionsStep.vue';
import DisclosuresStep from '@/components/SuperApp/Awareness/LeedForm/Meta/DisclosuresStep.vue';
import EndingStep from '@/components/SuperApp/Awareness/LeedForm/Meta/EndingStep.vue';
import apiClient from "@/core/buildRequest";
import { useSuperLeedForm } from "@/store/SuperLeedForm";

export default {
    name: 'LeadFormDialog',
    components: {
        QuestionsStep,
        DisclosuresStep,
        EndingStep
    },
    data() {
        return {
            dialog: true,
            activeTab: 'meta',
            currentStep: 0,
            store: useSuperLeedForm(),
            tabs: [
                {
                    label: 'Meta',
                    value: 'meta',
                    image: require('@/components/SuperApp/ReviewPageIcon/facebook.svg'),
                },
                {
                    label: 'Snapchat',
                    value: 'snapchat',
                    image: require('@/components/SuperApp/ReviewPageIcon/snap.svg'),
                },
                {
                    label: 'Tiktok',
                    value: 'tiktok',
                    image: require('@/components/SuperApp/ReviewPageIcon/tiktok.svg'),
                },
            ],
            steps: ['Form Details', 'Questions', 'Disclosures', 'Ending'],
            formName: '',
            enableGreeting: true,
            toggleGreeting: true,
            headline: '',
            description: '',
            Selectedmeta: null,
            Optionmeta: [],
            loadingMeta: false,
            metaLoaded: false,
            fallbackImage: "",
            error: [],
        };
    },
    computed: {
        currentComponent() {
            const key = this.steps[this.currentStep].replace(/\s+/g, '') + 'Step';
            return key;
        },
    },
    methods: {
        async onOpenSelect(isOpen) {
            if (isOpen && !this.metaLoaded) {
                this.loadingMeta = true;
                try {
                    const res = await apiClient.get("/publish-posts/all/pages");
                    this.Optionmeta = res.data?.data || [];
                    this.metaLoaded = true;
                } catch (err) {
                    console.error("Failed to load Meta Pages:", err);
                    this.Optionmeta = [];
                } finally {
                    this.loadingMeta = false;
                }
            }
        },

        validate() {
            this.error = [];

            const { formName, enableGreeting, headline, description } = this.store.MetaLeedDetails;

            if (!formName?.trim()) {
                this.error.push("Form name is required");
            }

            if (enableGreeting) {
                if (!headline?.trim()) {
                    this.error.push("Headline is required");
                }

                if (!description?.trim()) {
                    this.error.push("Description is required");
                }
            }

            return this.error.length === 0;
        }
    },
};
</script>

<style scoped>
.text-error {
    color: #e53935 !important;
    font-size: 15px;
    margin-top: 6px;
}

.border-bottom {
    border-bottom: 1px solid #eee;
}

.border-top {
    border-top: 1px solid #eee;
}

.tab-header {
    gap: 20px;
}

.tab-button {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding-bottom: 6px;
    font-weight: 500;
    font-size: 14px;
    color: #888;
    border-bottom: 2px solid transparent;
}

.tab-button.active {
    color: #000;
    border-bottom: 2px solid #066f63;
}

.sidebar {
    width: 200px;
    background: #f8f9fa;
    padding: 24px 16px;
    border-right: 1px solid #eee;
}

.sidebar-item {
    padding: 10px 14px;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;
    margin-bottom: 8px;
    color: #333;
    transition: all 0.2s;
}

.sidebar-item.active {
    background: #e0f3ef;
    color: #066f63;
    font-weight: 600;
}

.form-section {
    margin-bottom: 16px;
}

.form-label {
    font-weight: 500;
    font-size: 14px;
    display: block;
    margin-bottom: 6px;
}

.form-input {
    width: 100%;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 14px;
    outline: none;
    background-color: white;
}

.form-textarea {
    width: 100%;
    min-height: 100px;
    resize: vertical;
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 14px;
    background-color: white;
}

.form-box {
    background: #fff;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0px 2px 12px rgba(102, 102, 102, 0.12);
}

.form-box-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    margin-bottom: 8px;
}

.form-note {
    font-size: 13px;
    color: #666;
    margin-bottom: 16px;
}

.switch {
    position: relative;
    display: inline-block;
    width: 36px;
    height: 20px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 20px;
}

.slider:before {
    position: absolute;
    content: "";
    height: 14px;
    width: 14px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
}

input:checked+.slider {
    background-color: #237276;
}

input:checked+.slider:before {
    transform: translateX(16px);
}

.required {
    color: red;
}

.next-btn {
    background-color: #237276;
    color: white;
    padding: 8px 32px;
    border-radius: 8px;
    font-weight: 500;
    text-transform: none;
    min-width: 96px;
    min-height: 36px;
}

.next-btn:hover {
    background-color: #1c5e5c;
}

.dialog-close-icon {
    cursor: pointer;
    color: #888;
    z-index: 2;
    transition: color 0.2s;
}

.dialog-close-icon:hover {
    color: #000;
}
</style>
